module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "inputrow",
    attrs: {
      "width": "100"
    }
  }, [_c('span', {
    staticClass: "smart",
    on: {
      "click": _vm.useSmart
    }
  }, [_vm._v(_vm._s(_vm.smart))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.garment),
      expression: "garment"
    }],
    staticClass: "garment",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.garment)
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.garment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "smart-measurements"
  }, [_vm._v("S: " + _vm._s(_vm.smartMeasurements))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d07374","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GarmentConfig.vue
// module id = 498
// module chunks = 1